<!--
Inclusive announcement for homepage.
Usage: <Notice canDismiss="canDismiss" category="category" />
@author crm4f
-->
<template>
    <div v-if="isValidTimeframe() && notice != ''" :class="notice.elementValue == '' ? 'cwDiv-hide' : 'cwDiv'">
      <div class="cwContainer">
        <h1 class="cwHeader">{{ noticeTitle }}</h1>
        <div v-if="noticeHasPara" class="cwContent">
          <div id="contain" class="container" >
            <div class="announce-content" v-bind:key="index" v-for="(content, index) in noticeContent">
              {{ content }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="props.canDismiss" class="dismissContainer">
        <font-awesome-icon @click="dismiss()" id="dismiss" icon="fa-solid fa-x" size="lg"></font-awesome-icon>
      </div>
    </div>
  </template>
  
<script setup>
import axios from 'axios'
import { ref, onMounted } from 'vue'
import * as lst from '@/components/localStorage.js'
  
  onMounted(() => {
    getCurrentAppTheme()
  })

  const props = defineProps({
    theme: {
      type: String,
      required: false
    },
    canDismiss: Boolean
  })
  
  const notice = ref('')
  // in the db, title and content of announcements are seperated by '|'. Var to hold whether or not this is the case.
  const noticeHasPara = ref(false)
  const noticeTitle = ref('')
  const noticeContent = ref('')
  const currentAppTheme = ref(1)


  function dismiss () {
    lst.setValue('showHomepageNotice', false)
    notice.value = ''
  }
    /* TODO: crm4f included this as a computed value so rewrite  */
  function isValidTimeframe() {
    const valid = (Date.now() < notice.value.endTime) && (Date.now() > notice.value.startTime)
    return valid
  }

function getCurrentAppTheme() {
  axios.get('/timetable/banners/category/42', {})
    .then(response => {
      // get the app-wide theme id
      let banners = response.data.banners
      if (typeof banners !== 'undefined' && banners.length > 0) {
        currentAppTheme.value = banners[0].content
        getNotice()
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

  function getNotice() {
    axios.get('/timetable/theme/element/' + currentAppTheme.value + '/' + 'homepage_message', {})
    .then(response => {
      console.log(response)
      notice.value = response.data
      if (notice.value != '' && notice.value.elementValue.indexOf('|') > -1) {
        noticeHasPara.value = true
        noticeTitle.value = notice.value.elementValue.split('|')[0]
        noticeContent.value = notice.value.elementValue.split('|').slice(1)
      } else {
        noticeTitle.value = notice.value.elementValue
      }
    })
  }
  
  
</script>
  
<style scoped>
  
  .cwDiv-hide {
      display: none;
  }
  
  .cwDiv {
    background: rgba(0, 56, 101, 0.2);
    border-radius: 8px;
    margin-left:5%;
    margin-right:5%;
    margin-bottom:12px;
    padding-bottom:2px;
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
  }
  
  .cwHeader {
    margin-left:24px;
    font-family: PTSans;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    color:#003865;
    text-align:left;
    padding-top:12px;
  }
  
  .cwContent {
    padding-left:24px;
    padding-right:10px;
  }
  
  .dismissContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 6px;
    padding-right: 6px;
  }
  
  #dismiss {
    width: 21px;
    height: 21px;
    cursor: pointer;
    color: #003865
  }
  
</style>
  